import ResizeObserver from 'resize-observer-polyfill';

const addPolyfills = () => {
  // it is needed for current implementation of resizable table
  if (window && !window.ResizeObserver) {
    window.ResizeObserver = ResizeObserver;
  }
};

export default addPolyfills;
